import { DistanceUnitBase } from "./beacon-distance-helper";
import { ModelLocation as Location, haversineDistance } from "./location";

const isMetric = navigator.language.slice(-2) != "US";

export interface DistanceModel {
    distance: number
    unitLong: string
    unitShort: string
}

export function getNeededDistanceModel(parameters: { cameraLocation: Location, beaconLocation: Location, useYards: boolean, userData: Record<string, any> }): DistanceModel | null {
    const unitBase = parameters.useYards ? DistanceUnitBase.yards : (isMetric ? DistanceUnitBase.meters : DistanceUnitBase.feet);

    const distance = haversineDistance(parameters.cameraLocation, parameters.beaconLocation);

    const displayDistance = distance.beaconDistance(unitBase);
    const previousDisplayDistance = parameters.userData.distance as number;

    if (displayDistance == previousDisplayDistance) {
        return null;
    }

    parameters.userData.distance = displayDistance;

    return {
        distance: displayDistance,
        unitLong: distance.beaconDistanceUnitLong(unitBase),
        unitShort: distance.beaconDistanceUnitShort(unitBase)
    };
}